import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

export const CREDIT_LIMIT_CHANGED = prefix('CREDIT_LIMITS_CHANGED');
export const [CREDIT_LIMIT_CHANGE_STARTED, CREDIT_LIMIT_CHANGE_SUCCEEDED, CREDIT_LIMIT_CHANGE_FAILED] =
    createAsyncActionTypes(CREDIT_LIMIT_CHANGED);
